var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"white--text text-center",attrs:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.$t('general.offline'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }